<template>
    <div class="top" :class="{'location':isFixed,'van-hairline--bottom':borderShow}" :style="{'background-color': options.bgColor,'border-width':options.borderWidth, 'color':options.navColor}">
        <div class="img" @click="()=>{this.$emit('leftIconFun')}">
            <img class="left-img" v-if="imgSrc=='back'" src="../assets/img/icon/ArrowleftBlack.png" alt="">
            <img class="left-cancelimg" v-if="imgSrc=='cancel'" src="../assets/img/icon/pushClose.png" alt="">
            <img class="left-img" v-if="imgSrc=='white'" src="../assets/img/icon/Arrowleft.png" alt="">
        </div>
        <slot name="content"></slot>
        <div><slot name="right-btn"></slot></div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
            
            };
        },
        props: {
            title: {
                type:String,
                default:'',
                required:false
            },
            operation: {
                type:String,
                default:'',
                required:false
            },
            isFixed:{
                type:Boolean,
                default:false,
                required:false
            },
            imgSrc:{
                type:String,
                default:"back"
            },
            borderShow:{
                type:Boolean,
                default:true
            },
            options: {
				type: Object,
				default() {
					return {
						// 面板背景色
                        bgColor: '',
                        borderWidth:'',
						// 导航字体颜色
						navColor: '#000000',
					} 
				}
			},
        },
        created(){
        },
        methods: {
            handle(){
                this.$parent.topHandle();
            }
        }
    }
</script>
<style scoped lang='less'>
.location{position: fixed;top: 0;left: 0; right: 0;}
h2{
    font-size:28px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:20px;
}
.left-cancelimg{
    width: 34px;
    height: 34px;
}
.left-img{
    width: 20px;
    height: 36px;
}
.img{
        width: 20px;
        height: 36px;
    }
.top{
    padding: 0 36px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #ffffff;
    height: 89px;
    border-bottom: 1px solid #f5f5f5;
}
    
</style>